import URIS from 'constants/uris';
import http from 'services/http';

getPermissions.operation = 'READ';
getPermissions.idFrom = () => 'permissionsId';
export function getPermissions() {
  return http.get(URIS.PERMISSIONS);
}
